import { SignIn, SignUp } from "@clerk/react";
import { LumiMascot, SparkMascot } from "@/components/Mascots";

const Wrapper = ({ children }) => (
  <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 relative">
    <div className="pointer-events-none absolute top-10 left-10 hidden lg:block">
      <LumiMascot size={120} />
    </div>
    <div className="pointer-events-none absolute bottom-10 right-10 hidden lg:block">
      <SparkMascot size={120} />
    </div>
    {children}
  </div>
);

export const SignInPage = () => (
  <Wrapper>
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </Wrapper>
);

export const SignUpPage = () => (
  <Wrapper>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </Wrapper>
);
